import { UserClient } from "@/modules/auth/constant/client.user";
// import { UserClient } from "@/modules/auth/constant/client.mock";
let user = JSON.parse(localStorage.getItem("user"));
const resource = "/" + (user?.role ?? "customer") + "/factor";

export const orderRepository = {
  getAll: () => UserClient.get(`${resource}`),
};